import { MethodTypeRepository, Pipeline, PipelineEnvironment } from '@telespot/domain';

export interface AssignedPipelineOutput {
  id: string;
  name: { [lang: string]: string };
  env: PipelineEnvironment;
  createdAt: Date;
}

export interface IListAssignedPipelinesQuery {
  /**
   * Lists the pipelines assigned to a method type (via `ProtocolPipeline`),
   * backed by `MethodTypeRepository.getPipelinesAssigned` called without an
   * environment filter, so it returns the full assigned set across all
   * environments — callers paginate it client-side. Each pipeline is projected to
   * id / localized name / environment. Repository errors propagate so the caller's
   * pagination effect can surface them.
   */
  execute(methodTypeId: string): Promise<AssignedPipelineOutput[]>;
}

export class ListAssignedPipelinesQuery implements IListAssignedPipelinesQuery {
  constructor(private readonly methodTypeRepository: MethodTypeRepository) {}

  public async execute(methodTypeId: string): Promise<AssignedPipelineOutput[]> {
    const pipelines = await this.methodTypeRepository.getPipelinesAssigned(methodTypeId);
    return pipelines.map((pipeline: Pipeline) => ({
      id: pipeline.id,
      name: pipeline.name,
      env: pipeline.env,
      createdAt: pipeline.createdAt,
    }));
  }
}
